import React from "react";
import { CheckCircle2 } from "lucide-react";
import { motion } from "framer-motion";
import { useSeo } from "@/hooks/useSeo";
import { PrimaryButton, OutlineButton } from "@/components/Buttons";

export default function Bedankt() {
  useSeo({ title: "Bedankt | Imperium Group", description: "Bedankt voor je aanvraag bij Imperium Group. Wij nemen zo snel mogelijk contact met je op.", path: "/bedankt" });

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#090B0E] px-6 py-32" data-testid="bedankt-page">
      <motion.div initial={{ opacity: 0, scale: 0.94 }} animate={{ opacity: 1, scale: 1 }} transition={{ duration: 0.6 }} className="max-w-xl text-center">
        <span className="mx-auto flex h-20 w-20 items-center justify-center rounded-full bg-[#FF4500]/10 text-[#FF4500] glow-flame">
          <CheckCircle2 className="h-11 w-11" />
        </span>
        <h1 className="mt-8 font-display text-4xl font-extrabold tracking-tight text-white lg:text-5xl">Bedankt voor je aanvraag!</h1>
        <p className="mt-5 text-lg leading-relaxed text-slate-300">
          We hebben je gegevens ontvangen. Ons team neemt zo snel mogelijk contact met je op om jouw marketing te bespreken.
        </p>
        <div className="mt-10 flex flex-col items-center justify-center gap-4 sm:flex-row">
          <PrimaryButton to="/" testid="bedankt-home-btn">Terug naar home</PrimaryButton>
          <OutlineButton to="/diensten" testid="bedankt-diensten-btn">Bekijk onze diensten</OutlineButton>
        </div>
      </motion.div>
    </div>
  );
}
